import { getCategoryHref } from '../../utils/common/category';
import { STARTUP_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'startupIdeaGeneratorType',
      analyticsName: 'startup_idea_type',
      textLabel: 'Generate startup ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: STARTUP_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Startup',
        value: getCategoryHref(STARTUP_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'startupIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'startup_ideas_generator',
      placeholder: 'Try "health tech in Indonesia" or "sustainable food in North Europe"',
      textLabel: 'Describe the environment',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: STARTUP_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
